import { render, staticRenderFns } from "./ContactLine.vue?vue&type=template&id=31f37cc5&scoped=true"
import script from "./ContactLine.vue?vue&type=script&lang=js"
export * from "./ContactLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f37cc5",
  null
  
)

export default component.exports